import store from "../store/index"
import { axiosApi, uploadApi } from "./api"
import { dayEnd, dayStart, yearStart, yearEnd, monthStart, monthEnd } from '../util/DateUtil'
import Axios from "axios"

/**
 * API 列表
 * @type {function(*=): *}
 */

// 获取所有区域
export const GET_AREAS = function () {
    return axiosApi("get", "/area/project/all")({
        projectId: store.getters.projectId
    })
}

// 获取区域所有的回路 包含主回路
export const GET_AREA_LOOPS = function (areaId) {
    return axiosApi("get", "/loop/area/all/details")({
        areaId
    })
}

// 回路图表数据  按天获取
export const LOOP_DIAGRAM_DATA_BY_DAY = function (loopId, node, date, source) {
    let start = dayStart(date)
    let end = dayEnd(date)
    return LOOP_DIAGRAM_DATA(loopId, node, start, end, 'h', source)
}


// 回路图表数据  按月获取
export const LOOP_DIAGRAM_DATA_BY_MONTH = function (loopId, node, date, source) {
    let start = monthStart(date)
    let end = monthEnd(date)
    return LOOP_DIAGRAM_DATA(loopId, node, start, end, 'd', source)
}

// 回路图表数据  按年获取
export const LOOP_DIAGRAM_DATA_BY_YEAR = function (loopId, node, date, source) {
    let start = yearStart(date)
    let end = yearEnd(date)
    return LOOP_DIAGRAM_DATA(loopId, node, start, end, 'm', source)
}

export const LOOP_POINT_MAX_VAL_DAY = (loopId, node, d) => {
    return POINT_VAL(loopId, node, dayStart(d), dayEnd(d), "/power/loop/max/val")
}
export const LOOP_POINT_MAX_VAL_MONTH = (loopId, node, d) => {
    return POINT_VAL(loopId, node, monthStart(d), monthEnd(d), "/power/loop/max/val")
}

export const LOOP_POINT_MIN_VAL_DAY = (loopId, node, d) => {
    return POINT_VAL(loopId, node, dayStart(d), dayEnd(d), "/power/loop/min/val")
}
export const LOOP_POINT_MIN_VAL_MONTH = (loopId, node, d) => {
    return POINT_VAL(loopId, node, monthStart(d), monthEnd(d), "/power/loop/min/val")
}
export const LOOP_POINT_MEAN_VAL_DAY = (loopId, node, d) => {
    return POINT_VAL(loopId, node, dayStart(d), dayEnd(d), "/power/loop/mean/val")
}
export const LOOP_POINT_MEAN_VAL_MONTH = (loopId, node, d) => {
    return POINT_VAL(loopId, node, monthStart(d), monthEnd(d), "/power/loop/mean/val")
}

export const EXTREMUM_VALUES = (ids, nodes, type, start, end) => {
    return axiosApi("get", "/extremum/values")({
        ids: ids.join(","),
        nodes: nodes.join(","),
        type,
        start,
        end
    })
}


const POINT_VAL = (loopId, node, start, end, api) => {
    return axiosApi("get", api)({
        loopId,
        node,
        start,
        end
    })
}



// 获取回路数据
const LOOP_DIAGRAM_DATA = function (loopId, node, start, end, type, source) {
    if (type === 'h') {
        node += '_1h'
    }
    if (type === 'd') {
        node += '_1d'
    }
    if (type === 'm') {
        node += '_1m'
    }

    return axiosApi("get", "/diagram/loop/historycurve", false, source ? source.token : Axios.CancelToken.source().token)({
        deviceLoopId: loopId,
        node,
        start,
        end
    })
}


// 原始influxdb 数据
export const INFLUX_QUERY = (ids, start, end, group, nodes) => {

    return axiosApi("post", "/diagram/influxdb/data", true)({
        "deviceLoopIdList": ids,
        start,
        end,
        group,
        "nodes": nodes,
        // "nodes": [
        // 	"PA_total"
        // ],
        projectId: store.getters.projectId
    })
}


// 能源分析数据
export const POWER_ANALYSIS_BY_LOOP = (d, range, loopId) => {
    let start
    let end
    if (range === 'year') {
        start = yearStart(d)
        end = yearEnd(d)
    } else {
        start = monthStart(d)
        end = monthEnd(d)
    }

    return axiosApi("get", "/power/powerAnalysis/loop")({
        deviceLoopId: loopId,
        start,
        end
    })
}


export function transformerList(aid) {
    return axiosApi("get", "/device/transformer/list")({ areaId: aid })
}

export function breakerList(aid) {
    return axiosApi("get", "/loop/breaker/list")({ areaId: aid })
}


//最大负荷
export function influx_load(ids, start, end, group, nodes) {
    return axiosApi("post", "/diagram/influxdb/data/load", true)({
        "deviceLoopIdList": ids,
        start,
        end,
        group,
        // "nodes":nodes,
        "nodes": [
            "Ia", "Ib", "Ic"
        ],
        projectId: store.getters.projectId
    })
}

//负载
export function influx_workload(id) {
    return axiosApi("get", "/diagram/influxdb/data/workload", true)({
        deviceLoop: id,
        projectId: store.getters.projectId
    })
}

// 通过区域ID获取电容补偿柜
export function LowFeedDevice(id) {
    return axiosApi("get", "/device/capacitorCompensation/details", true)({
        areaId: id
    })
}
// 弧光保护
export function Arcprotection(areaId) {
    return axiosApi("get", "/loop/arc/list", true)({
        areaId: areaId
    })
}

// 谐波分析
export function harmonicAnalysis(projectId) {
    return axiosApi("get", "/loop/all", true)({
        projectId: projectId
    })
}

//用电综览
export function overviewPowerNumber() {
    return axiosApi("get", "/power/mainloops/power-number", true)({
        projectId: store.getters.projectId
    })
}
//用电综览-馈线
export function PowerNumber() {
    return axiosApi("get", "/power/feeder/power-number", true)({
        projectId: store.getters.projectId
    })
}
//月用电曲线
export function mainloopMonth(dateRange) {
    return axiosApi("get", "/diagram/mainloops/power/historycurve", true)({
        projectId: store.getters.projectId,
        dateRange:dateRange
    })
}
 
//用电排名
export function powerRankings(date) {
    return axiosApi("get", "/power/loops/power/rankings", true)({
        projectId: store.getters.projectId,
        date:date
    })
}

//月用电曲线
export function powerConsumptionarea() {
    return axiosApi("get", "/diagram/power/consumptionarea/month", true)({
        projectId: store.getters.projectId
    })
}


//获取变压器当日最大负载总和
export function diagramdaily(areaId) {
    return axiosApi("get", "/diagram/load/transformer/all/daily", true)({
        areaId
    })
}

//今日用电 -有功
export function powertotal(projectId,start,end) {
    return axiosApi("get", "/power/total", true)({
        projectId,start,end
    })
}
//无功
export function powerReactive(projectId,start,end) {
    return axiosApi("get", "/power/total/reactive", true)({
        projectId,start,end
    })
}

//逆变器
export function InverterArea(areaId) {
    return axiosApi("get", "/loop/inverter/area", true)({
        areaId
    })
}


//运行概况
export function DailyHistorycurve(obj) {
    return axiosApi("get", "/diagram/historycurve/daily/inverter")(obj)
}

//发电统计
export function dailyPower(obj) {
    return axiosApi("get", "/diagram/historyCurve/dailyPower/inverter")(obj)
}

//逆变器曲线
export function dailyInverter(obj) {
    return axiosApi("get", "/diagram/historyCurve/dailyPower/inverter/loop")(obj)
}


//发电量报表
export function InverterLoop(obj) {
    return axiosApi("get", "/diagram/historyCurve/Power/inverter/loop")(obj)
}